export default "__VITE_ASSET__ChpEMKOq__"